export default __webpack_public_path__ + "static/media/動かしたい.c5446f7b.png";